export const USER_ROLES = {
    ADMIN : "Admin",
    USER : "User",
    CONSULTANT : "Consultant",
  };